import { WIDGET_CONFIG_LABEL_DEFAULT } from './widget.constant';
import { StringParam, useQueryParam, withDefault } from 'use-query-params';

export const useAdminWidgetConfigLabelQueryParam = () =>
    useQueryParam('config-label', withDefault(StringParam, WIDGET_CONFIG_LABEL_DEFAULT));
